import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
type Testimonial = {
  quote: string;
  name: string;
  role: string;
  country: string;
  image: string;
};
const TESTIMONIALS: Testimonial[] = [{
  quote: 'Antes perdía muchísimo tiempo revisando artículos para cada caso. Hoy tengo un sistema claro que me guía en cuestión de minutos.',
  name: 'Dr. Carlos M.',
  role: 'Medicina interna',
  country: 'Colombia',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/a2fed565-3bb5-4ba2-8db5-31ecf09e8fb8.jpg'
}, {
  quote: 'Lo mejor no son los tomos. Son los algoritmos. Los utilizo prácticamente todos los días.',
  name: 'Dr. Alejandro R.',
  role: 'Medicina general',
  country: 'México',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/e2f8fd5d-afae-40b0-be27-6c6b0346c359.jpg'
}, {
  quote: 'Es la primera vez que encuentro un material que realmente organiza toda la TRT de forma práctica.',
  name: 'Dra. Patricia V.',
  role: 'Endocrinología',
  country: 'Argentina',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/8e1062ce-144d-4014-90f7-08c3358894fb.jpg'
}, {
  quote: 'El Tomo V resolvió dudas que llevaba años intentando aclarar.',
  name: 'Dr. Jorge H.',
  role: 'Andrología',
  country: 'España',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b4a23d00-6363-44b9-8f8c-d65ca7ac83ff.jpg'
}];
export function Testimonials() {
  return <section className="w-full bg-cream-100 py-12 sm:py-16" aria-labelledby="testimonials-title" data-id="element-210" data-mp="14xde4gbs0aj3">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-211" data-mp="q4sbimsmmzpm">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-212" data-mp="v4o65vffpesi">
          Lo que ya dicen otros profesionales
        </p>
        <h2 id="testimonials-title" className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-213" data-mp="1nm0i0vi7utv3">
          Médicos que ya decidieron con más seguridad
        </h2>

        <div className="mt-7 grid grid-cols-1 gap-3.5 sm:grid-cols-2" data-id="element-214" data-mp="1sjz7qzb6serx">
          {TESTIMONIALS.map(testimonial => <figure key={testimonial.name} className="flex h-full flex-col rounded-2xl border border-navy-900/10 bg-white p-4 shadow-[0_10px_26px_-22px_rgba(11,32,56,0.6)]" data-id="element-215" data-mp="1ofreqpxp4cnw">
              <div className="flex items-center gap-1" aria-label="5 de 5 estrellas" data-id="element-216" data-mp="1el7wdknpl77h">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-217" data-mp="14stpkdhrxaeg" />)}
              </div>
              <blockquote className="relative mt-3 grow" data-id="element-218" data-mp="vrlt80ytijn0">
                <QuoteIcon className="absolute -left-0.5 -top-1 h-5 w-5 text-cream-200" aria-hidden="true" data-id="element-219" data-mp="qtk8lblquc9f" />
                <p className="relative text-[14.5px] font-medium leading-relaxed text-navy-800" data-id="element-220" data-mp="32ge55awa7k0t">
                  “{testimonial.quote}”
                </p>
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-navy-900/10 pt-3.5" data-id="element-221" data-mp="3cgep8z1z6462">
                <img src={testimonial.image} alt={`Retrato de ${testimonial.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-gold-500/40" loading="lazy" data-id="element-222" data-mp="3gfdn5zpah0o0" />
                <div className="min-w-0" data-id="element-223" data-mp="2sqktyb01x6x3">
                  <p className="text-[14px] font-bold leading-tight text-navy-900" data-id="element-224" data-mp="2spt4zj0ym7fs">
                    {testimonial.name}
                  </p>
                  <p className="text-[12px] font-medium leading-tight text-navy-800/65" data-id="element-225" data-mp="2106l4t6waksa">
                    {testimonial.role} · {testimonial.country}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta label="Quiero los mismos resultados en mi consulta" data-id="element-226" data-mp="1lusp1sryujpm" />
      </div>
    </section>;
}